import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plug, Unplug } from 'lucide-react';
import { useFtpStore } from '../../store/ftpStore';

/**
 * The pane of a connection whose server stopped answering (owner 11.10.2026:
 * after a night asleep it still looked connected). Says so, shows the server's
 * last word small, and reconnects on one click — like FileZilla's
 * "Disconnected from server" and WinSCP's Reconnect.
 */
export default function FtpConnectionLost({ connId, reason }) {
  const { t } = useTranslation();
  return (
    <div className="ftp-view">
      <div className="ftp-empty" role="status">
        <div className="ftp-empty-icon">
          <Unplug size={24} />
        </div>
        <span className="ftp-empty-title">{t('ftp.connectionLost')}</span>
        <span className="ftp-empty-sub">{t('ftp.connectionLostHint')}</span>
        {reason && <span className="ftp-empty-sub ftp-empty-sub--error">{reason}</span>}
        <button
          type="button"
          onClick={() => useFtpStore.getState().connect(connId)}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors modern-button text-sm"
          style={{ marginTop: 8, display: 'inline-flex', alignItems: 'center', gap: 6 }}
        >
          <Plug size={14} /> {t('ftp.reconnect')}
        </button>
      </div>
    </div>
  );
}
